import React, { useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./routes";
import { AuthProvider } from "./context/AuthContext";


export default function App() {

useEffect(() => {
    const expiry = localStorage.getItem("tokenExpiry");
    const token = localStorage.getItem("token");
    const now = new Date().getTime();

    // Check if token exists and if it has expired
    if (token && expiry && now > parseInt(expiry)) {
      localStorage.removeItem("token");
      localStorage.removeItem("tokenExpiry");
      // Use window.location to force a clean state redirect
      window.location.href = "/login";
    }
  }, []);

  return (
 <Router>
  <AuthProvider>
      <AppRoutes />
      </AuthProvider>
    </Router>
  );
}